"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var react_1 = tslib_1.__importDefault(require("react"));

var react_dom_1 = require("react-dom");

var root_1 = require("./styled/root");

var Overlay = function Overlay(_a) {
  var __UIScope = _a.__UIScope,
      className = _a.className,
      isFullScreen = _a.isFullScreen,
      rest = tslib_1.__rest(_a, ["__UIScope", "className", "isFullScreen"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Overlay',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  if (isFullScreen) {
    return (0, react_dom_1.createPortal)(react_1.default.createElement(root_1.Root, tslib_1.__assign({
      className: rootClasses,
      isFullScreen: isFullScreen
    }, rest)), document.body);
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses
  }, rest));
};

exports.Overlay = Overlay;